export default __webpack_public_path__ + "static/Inter-Black-143c28420846d45c5834d08008161554.ttf";